export default {
	skills: [],
	totalSkills: 0,
	listSelectedSkills: [],
	checkedSkills: [],
	skillIds: [],
};
